import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import type { Bureau } from '../interfaces/bureaux';
import type Collectivite from '../interfaces/collectivite';
import type { DemandeCompte } from '../interfaces/demandeCompte';
import type CreatePastellUserResponse from '../interfaces/utilisateur';
import type {
	UtilisateurCollectivite,
	UtilisateurCollectiviteToCreate,
} from '../interfaces/utilisateurCollectivite';

export const replacePastellUser = async (
	idDemandeDecompte: number,
	ancienUtilisateur: UtilisateurCollectivite,
) =>
	request.post<unknown, TemplateRequestGet<DemandeCompte>>(
		`/api/ixchange/pastell/utilisateurFromDemandeCompte/${idDemandeDecompte}`,
		{
			utilisateur: ancienUtilisateur,
		},
	);

export const postPastellUser = async (
	user: UtilisateurCollectiviteToCreate,
	certificatFile?: File,
) => {
	const formData = new FormData();
	formData.append('utilisateur', JSON.stringify(user));

	if (certificatFile) {
		formData.append('certificatFile', certificatFile);
	}

	return request.post<FormData, CreatePastellUserResponse>(
		'/api/ixchange/pastell/utilisateurIxchange',
		formData,
	);
};

export const deletePastellUser = async (
	utilisateur: UtilisateurCollectivite,
) => {
	if (!utilisateur.collectivites?.length) {
		throw new Error(
			'Impossible de supprimer un utilisateur sans collectivité associée',
		);
	}
	return request.put<unknown, UtilisateurCollectivite>(
		`/api/ixchange/pastell/deleteUtilisateurIxchange/${utilisateur.collectivites[0].id_e}`,
		utilisateur,
	);
};

export const getBureaux = async () =>
	request.get<unknown, Collectivite[]>('/api/ixchange/pastell/bureaux');

export const updateBureau = async (
	utilisateur: UtilisateurCollectivite,
	bureauxAjoutes: Bureau[],
	bureauxSupprimes: Bureau[],
) => {
	if (!utilisateur.collectivites?.length) {
		throw new Error(
			'Impossible de modifier les bureaux sans collectivité associée',
		);
	}
	return request.put<unknown, UtilisateurCollectivite>(
		`/api/ixchange/pastell/addActeurBureau/${utilisateur.collectivites[0].id_e}`,
		{
			addToDesks: bureauxAjoutes,
			deleteFromDesks: bureauxSupprimes,
		},
	);
};
